import { Component, OnChanges } from '@angular/core'

import { QuestionTypeView, QuestionViewService, IQuestionAnswer } from '../'

const BOOTSTRAP_LAYOUT_OPTIONS = Object.freeze({
  TOTAL_COLUMN_WIDTH: 12,
  DESIRED_ELEMENT_COLUMN_WIDTH: 4
})

@Component({
  selector: 'mp-text-completion-question-view',
  templateUrl: './text-completion-question-view.html',
  styleUrls: ['./text-completion-question-view.scss']
})
export class TextCompletionQuestionViewComponent extends QuestionTypeView implements OnChanges {
  public horizontalAnswerChoicesOffset: number
  public desiredColumnWidth = BOOTSTRAP_LAYOUT_OPTIONS.DESIRED_ELEMENT_COLUMN_WIDTH

  private _questionAnswers: { [key: number]: IQuestionAnswer} = {}

  public get answerChoiceGroups() {
    return this.question.answerChoiceGroups
  }

  public constructor(
    _questionViewService: QuestionViewService
  ) { super(_questionViewService) }

  public ngOnChanges() {
    this.horizontalAnswerChoicesOffset = this._calculateAnswerChoiceGroupBootstrapOffset()
    this._questionAnswers = this.formGroup.value.answerChoiceGroup.reduce((previous, value, index) => {
      if (value.answerChoice) {
        previous[index] = {choiceId: value.answerChoice, value: ''}
      }
      return previous
    }, {})
  }

  public onOptionSelected(questionAnswer: IQuestionAnswer, index: number) {
    this._questionAnswers[index] = questionAnswer
    this._questionViewService.questionAnswered.emit(Object.values(this._questionAnswers))
  }

  public getGroupTitle(index: number) {
    const numberOfI = 'i'.repeat(index + 1)
    return `Blank (${numberOfI})`
  }

  private _calculateAnswerChoiceGroupBootstrapOffset() {
    const answerChoiceGroupLength = this.answerChoiceGroups.length
    const contentColumnWidth = answerChoiceGroupLength * this.desiredColumnWidth
    return (BOOTSTRAP_LAYOUT_OPTIONS.TOTAL_COLUMN_WIDTH - contentColumnWidth) / 2
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/question-view/text-completion-question-view/text-completion-question-view.component.ts